import { ProductSizeSelectorMode, SelectorProductSize } from '../../domain/models/product-size-selector.model';

import { ProductPublicModels } from '@features/products/product';
import { checkCanShowSimilarUseCase } from '@shared/product/use-cases/product-modals.use-cases';
import { isProductSizeNotBuyableUseCase } from '@shared/product/use-cases/product-size.use-cases';

function hasDisabled(size: ProductPublicModels.PublicProductSize): boolean {
    return isProductSizeNotBuyableUseCase([size], ['DISABLED']);
}

function hasSelected(
    size: ProductPublicModels.PublicProductSize,
    selectedSize: ProductPublicModels.PublicProductSize
): boolean {
    if (selectedSize) {
        return selectedSize.sku === size.sku;
    }
    return false;
}

function isComingSoonSize(size: ProductPublicModels.PublicProductSize): boolean {
    if (!size.visibilityValue) {
        return false;
    }
    return isProductSizeNotBuyableUseCase([size], ['COMING_SOON']);
}

function isBackSoonSize(size: ProductPublicModels.PublicProductSize): boolean {
    if (!size.visibilityValue) {
        return false;
    }
    return isProductSizeNotBuyableUseCase([size], ['BACK_SOON']);
}

function showSimilarProduct(size: ProductPublicModels.PublicProductSize): boolean {
    if (!size.visibilityValue) {
        return false;
    }
    return checkCanShowSimilarUseCase(size);
}

function toSelectorProductSize(size: ProductPublicModels.PublicProductSize, selectedSize: ProductPublicModels.PublicProductSize, mode: ProductSizeSelectorMode = 'STANDARD'): SelectorProductSize {
    if (mode === 'ESSENTIAL' || mode === 'ESSENTIAL_MULTI') {
        return {
            ...size,
            hasDisabled: false,
            hasSelected: hasSelected(size, selectedSize),
            isComingSoon: false,
            isBackSoon: false,
            showSimilarProduct: false,
        };
    }

    return {
        ...size,
        hasDisabled: hasDisabled(size),
        hasSelected: hasSelected(size, selectedSize),
        isComingSoon: isComingSoonSize(size),
        isBackSoon: isBackSoonSize(size),
        showSimilarProduct: showSimilarProduct(size),
    };
}

export const ProductSizeSelectorTransformer = {
    toSelectorProductSize: toSelectorProductSize,
};

// Do not use the following export statement, its only for the purpose of testing
export const __test__ = {
    hasDisabled: hasDisabled,
    hasSelected: hasSelected,
    isComingSoonSize: isComingSoonSize,
    isBackSoonSize: isBackSoonSize,
    showSimilarProduct: showSimilarProduct,
};
